import React, {useEffect, useState} from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {
   isMobileWeb,
   isNewAPI,
   loinBackgroundColor,
   rotateDeviceMsg,
   webLandscapeViewStyle,
} from '../utils/utils';
import NorcatAlert from '../utils/norcat_alert';
import {createStackNavigator} from '@react-navigation/stack';
import ProfileScreen from '../screens/profile/ProfileScreen';
import DashboardScreen from '../screens/dashboard/DashboardScreen';
import {Platform, View, Dimensions} from 'react-native';
import QRAndBarcodeScreen from '../screens/qrandbar/QrAndBarcodeScreen';
import LogoutScreen from '../screens/profile/LogoutScreen';
import EditProfileScreen from '../screens/profile/EditProfileScreen';
import RecordDetailsScreen from '../screens/my_traning/RecordDetailsScreen';
import MyTrainingScreen from '../screens/my_traning/MyTrainingScreen';
import {CourseDetailsLoading} from '../screens/coursedetails/course_details_loading';
import ModuleDetails from '../screens/moduledetails/ModuleDetails';
import PlayerScreen from '../screens/player/PlayerScreen';
import BrowsesCoursesScreen from '../screens/browseCourses/BrowsesCoursesScreen';
import {ModulesContainer} from '../screens/moduledetails/ModulesContainer';
import {ModulesSlidesContainer} from '../screens/courseModuleSlide/ModuleSlidesContainer';
import CourseDescriptionScreen from '../screens/browseCourses/CourseDescription';
import {CourseResourceContainer} from '../screens/courseResources/CourseResourceContainer';
//import {CourseResourcePDFContainer} from '../screens/courseResources/CourseResourcePDFContainer';
import {StartFinalTest} from '../screens/reviewQuestions/StartFinalTest';
import {ScoreBoard} from '../screens/reviewQuestions/ScoreBoard';
import Attestation from '../screens/Attestation/Attestation';
import AttestationProfile from '../screens/Attestation/AttestationProfile';
import {WebViewContainer} from '../utils/WebViewContainer';
import {PaymentDetails} from '../screens/payment/paymentDetails';
import {WebViewContainerMacos} from '../utils/WebViewContainerMacos';
import {useDispatch, useSelector} from 'react-redux';
import {
   getIsTabletPortrait,
   getShowLandscapeMsg,
   selectLandscapeSmallWebView,
   selectScreenOrientation,
   setIsLandscapeSmallWebView,
   setIsLandscapemode,
   setIsTabletPortrait,
   setShowLandscapeMsg,
} from '../redux/slices/ScreenOrientationSlice';
import {
   clearResponseAlertData,
   getResponseAlertData,
   setPressOk,
} from '../redux/slices/ResponseAlertSlice';
import {selectAttestation, selectAuthData} from '../redux/slices/AuthSlice';
import CustomAlert from '../components/custom-alert/index.web';
import SplashScreen from '../components/splash';
import CustomToast from '../components/custom-toast/index.web';
import {isMobileOnly, isTablet} from 'react-device-detect';
import {logoutHandler} from '../service/network_access';
import {useNavigation} from '@react-navigation/native';
import logger from '../utils/logger';
import ResetPassword from '../screens/resetPassword/ResetPassword';

const Stack = createNativeStackNavigator();
const MacosStack = createStackNavigator();

//AppNavigator is used for authenticated users of the app.
const AppNavigator = ({navigation}) => {
   const dispatch = useDispatch();
   const myNav = useNavigation();
   const [ismacOSPlatform, setismacOSPlatform] = useState(
      Platform.OS === 'macos',
   );
   const isLandscapemode = useSelector(selectScreenOrientation);
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const showLandscapeMsg = useSelector(getShowLandscapeMsg);
   const isTabletPortraitMode = useSelector(getIsTabletPortrait);
   const responseAlertData = useSelector(getResponseAlertData);
   const isAttested = useSelector(selectAttestation);
   const [initialRouteName, setInitialRouteName] = useState(null);
   const authData = useSelector(selectAuthData);

   const webClickHandler = () => {
      const {callbackType} = responseAlertData;
      dispatch(clearResponseAlertData());
      if (callbackType === 'TOKEN_EXPIRED') {
         (() => {
            logoutHandler();
         })();
         navigation?.reset({
            index: 0,
            routes: [
               {
                  name: 'Login',
               },
            ],
         });
      }
      if (['UNLOCK_ACCOUNT', 'RESET_ACCOUNT'].includes(callbackType)) {
         myNav.navigate('DashboardScreen');
      }
      if (['TEST_ALREADY_COMPLETED'].includes(callbackType)) {
         //navigation.pop(2);
         dispatch(setPressOk());
      }
      if (callbackType === 'GO_BACK') {
         myNav.goBack();
      }
   };
   useEffect(() => {
      const isLandscapeListener = Dimensions.addEventListener(
         'change',
         ({window}) => {
            const screenWidth = Dimensions.get('window').width;
            const screenHeight = Dimensions.get('window').height;
            const isLandscapeMode = {
               isLandscapemode:
                  !isMobileOnly && screenWidth > screenHeight ? true : false,
            };
            const isLandscapeSmallWebView = {
               isLandscapeSmallWebView:
                  isMobileOnly &&
                  Math.max(screenHeight, screenWidth) > 450 &&
                  screenHeight < screenWidth,
            };
            const isTabletPortraitPayload = {
               isTabletPortrait: isTablet && screenHeight > screenWidth,
            };
            if (Platform.OS === 'web') {
               dispatch(setIsLandscapemode(isLandscapeMode));
               dispatch(setIsLandscapeSmallWebView(isLandscapeSmallWebView));
               dispatch(setIsTabletPortrait(isTabletPortraitPayload));
            }
         },
      );
   }, [
      dispatch,
      isLandscapemode,
      isLandscapeSmallWebView,
      isTabletPortraitMode,
   ]);
   useEffect(() => {
      setInitialRouteName(
         isNewAPI
            ? authData.ResetPassword
               ? 'ResetPassword'
               : !isAttested
               ? 'Attestation'
               : 'DashboardScreen'
            : 'DashboardScreen',
      );
   }, [isAttested, isNewAPI]);
   logger({initialRouteName});
   if (initialRouteName === null) {
      return <SplashScreen />;
   }
   return (
      <View>
         <Stack.Navigator
            initialRouteName={
               isNewAPI
                  ? authData.ResetPassword
                     ? 'ResetPassword'
                     : !isAttested
                     ? 'Attestation'
                     : 'DashboardScreen'
                  : 'DashboardScreen'
            }>
            <Stack.Screen
               name="DashboardScreen"
               component={DashboardScreen}
               options={{headerShown: false, title: 'Dashboard'}}
            />
            <Stack.Screen
               name="ResetPassword"
               component={ResetPassword}
               options={{headerShown: false, title: 'Reset Password'}}
            />
            <Stack.Screen
               name="ProfileScreen"
               component={ProfileScreen}
               options={{headerShown: false, title: 'View Profile'}}
            />
            <Stack.Screen
               name="EditProfileScreen"
               component={EditProfileScreen}
               options={{headerShown: false, title: 'Edit Profile'}}
            />
            <Stack.Screen
               name="QRAndBarcodeScreen"
               component={QRAndBarcodeScreen}
               options={{headerShown: false, title: 'QR And Barcode'}}
            />
            <Stack.Screen
               name="LogoutScreen"
               component={LogoutScreen}
               options={{headerShown: false, title: 'Logout'}}
            />
            <Stack.Screen
               name="MyTraningScreen"
               component={MyTrainingScreen}
               options={{headerShown: false, title: 'My Training'}}
            />
            <Stack.Screen
               name="RecordDetailsScreen"
               component={RecordDetailsScreen}
               options={{
                  headerShown: false,
                  title: 'Record Details',
               }}
            />
            <Stack.Screen
               name="courseLoading"
               component={CourseDetailsLoading}
               options={{headerShown: false, title: 'Module Details'}}
            />
            <Stack.Screen
               name="ModuleDetails"
               component={ModuleDetails}
               options={{
                  headerShown: false,
                  title: 'Module Details',
                  orientation: 'default',
               }}
            />
            <Stack.Screen
               name="PlayerScreen"
               component={PlayerScreen}
               options={{
                  headerShown: false,
                  title: 'Player Screen',
                  orientation: 'landscape',
               }}
            />
            <Stack.Screen
               name="BrowsesCoursesScreen"
               component={BrowsesCoursesScreen}
               options={{headerShown: false, title: 'Browse Courses'}}
            />
            <Stack.Screen
               name="CourseDescriptionScreen"
               component={CourseDescriptionScreen}
               options={{
                  headerShown: false,
                  title: 'Course Description',
               }}
            />
            <Stack.Screen
               name="ModulesContainer"
               component={ModulesContainer}
               options={{headerShown: false, title: 'Modules'}}
            />
            <Stack.Screen
               name="ModulesSlidesContainer"
               component={ModulesSlidesContainer}
               options={{
                  headerShown: false,
                  title: 'Module Slides',
                  orientation: 'default',
               }}
            />
            <Stack.Screen
               name="CourseResourceContainer"
               component={CourseResourceContainer}
               options={{
                  headerShown: false,
                  title: 'Course Resources',
                  orientation: 'default',
               }}
            />
            <Stack.Screen
               name="StartFinalTest"
               component={StartFinalTest}
               options={{
                  headerShown: false,
                  title: 'Start Final Test',
                  orientation: 'landscape',
               }}
            />
            <Stack.Screen
               name="ScoreBoard"
               component={ScoreBoard}
               options={{
                  headerShown: false,
                  title: 'Score Board',
                  orientation: 'landscape',
               }}
            />
            <Stack.Screen
               name="Attestation"
               component={Attestation}
               options={{headerShown: false, title: 'Attestation'}}
            />
            <Stack.Screen
               name="AttestationProfile"
               component={AttestationProfile}
               options={{headerShown: false, title: 'Attestation Profile'}}
            />
            <Stack.Screen
               name="WebViewContainer"
               component={WebViewContainer}
               options={{
                  headerShown: false,
                  title: 'Web View',
                  orientation: 'default',
               }}
            />
            <Stack.Screen
               name="PaymentDetails"
               component={PaymentDetails}
               options={{
                  headerShown: false,
                  title: 'Payment Details',
                  orientation: 'default',
               }}
            />
         </Stack.Navigator>
         {/* {responseAlertData?.showAlert && (
            <CustomAlert
               title={responseAlertData?.title}
               message={responseAlertData?.message}
               callbackType={responseAlertData?.callbackType}
               navigation={navigation}
            />
         )} */}
         {responseAlertData?.showAlert && (
            <NorcatAlert
               actionPositive={true}
               title={responseAlertData?.title}
               message={responseAlertData?.message}
               buttonText={'OK'}
               onCallBack={webClickHandler}
            />
         )}
         {showLandscapeMsg &&
            (isLandscapeSmallWebView || isTabletPortraitMode) && (
               <CustomToast message={rotateDeviceMsg} />
            )}
      </View>
   );
};

export default AppNavigator;
